import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';

import { IsClosed, IsOpen, View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { performAction } from '../../actions';
import { PerformActionButton } from '../PerformActionButton';
import { BaseCellComp } from '../BaseCellComp';
import { CellButton, CellButtons } from '../CellButton';
import { HBox, VBox } from '../../../../components/Box';
import { Row, Cell } from '../../../../components/List';
import { selectAllOptions, selectVehicle } from '../../../Vehicles/selectors';
import { setVehicleProperty } from '../../../Vehicles/actions';
import _ from 'lodash';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { VehiclePropertyLoadable } from '../../../Vehicles/components/VehiclePropertyLoadable';
import { WithVehicle } from '../../../Vehicles/components/WithVehicle';

import { Cell as ActionCell } from '../Cell';
import cn from 'classnames';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import styles from './WS_Default.module.css';
import s from './IDWE_quality_check_commerce.module.css';

import { selectMe } from '../../../Api/selectors';
import { DEFAULTS_TASK_FIELDS, VEHICLE_MILEAGE_CATEGORIES, VEHICLE_TASK_FIELDS } from '../../../Vehicles/constants';

import { VehicleFinancePurchaseCard } from '../../../Vehicles/components/CardFinancePurchase';
import { SearchSelect } from '../../../../components/SearchSelectComponent';
import { COLOR_PRIMARY_1 } from '../../../../vars';
import { KanbanVehicleRemarks } from '../../components/KanbanVehicleRemarks';
import env from '../../../../env';
import { AppClientId } from '../../../Shared/constants';
import { VehiclePropertyCheckbox } from '../../../Vehicles/components/VehiclePropertyCheckbox';
import { Card } from '../../../../components/Card';
import { Button } from '../../../../components/Buttons';
import { VehicleOutgoingInvoiceCard } from '../../../Vehicles/components/CardOutgoingInvoice';


dayjs.extend(customParseFormat);

const Container = styled.div`
  .modal-inner {
  }

  .pane {
    padding: 12px 0;
    border-bottom: 1px solid #eee;
    width: 100%;
    margin-bottom: 12px;
    border-bottom: none;

    .title {
      text-transform: uppercase;
    }
    h1 {
      font-size: 18px;
    }
  }

  .manco-list > div {
    margin: 12px 0;
  }

  .cell-value {
    text-align: right;
  }

  .basic-multi-select {
    min-width: 300px;
    max-width: 100%;
  }
  .triple {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin: 12px 0;

    .btn-check:checked + .btn {
      background-color: var(--color-new-secondary);
      border-color: var(--color-new-secondary);
      color: #fff; /* optioneel: tekst wit voor contrast */
      font-size: 12px;
    }
    .btn-check:not(:checked) + .btn {
      border-color: var(--color-new-primary);
      color: var(--color-new-primary);
      font-size: 12px;
    }

    transition: opacity 0.2s;
    .check {
      transition: opacity 0.2s;
      display: inline-block;
      width: 24px;
      height: 24px;
      border: 1px solid ${COLOR_PRIMARY_1};
      color: ${COLOR_PRIMARY_1};
      text-align: center;
      font-size: 21px;
      line-height: 20px;
    }

    &.triple-0 {
      .check {
      }
    }
    &.triple-1 {
      .check {
        border: 1px solid #3bb78e;
        color: #3bb78e;
      }
    }
    &.triple-4 {
      .check {
        border: 1px solid red;
        text-align: center;
        color: red;
      }
    }

    &.disabled {
      opacity: 0.4;
      .check {
        opacity: 0;
      }
    }
    @media (max-width: 425px) {
      font-size: 12px;
    }
  }
`;

const RequireMark = styled.span`
  margin-left: 4 px;
  font-size: 24px;
  color: red;
`;

const STATE = {
  approve: false,
  options: false,
  manco: false,
  task_attach_replate: '0',
  ...DEFAULTS_TASK_FIELDS,
  ...VEHICLE_TASK_FIELDS,
  changed: {},
  regplate_code: '',
};

/* eslint-disable react/prefer-stateless-function */
class IDWE_quality_check_commerceComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {

    this.timeout(() => this.setState({ showOutgoingInvoiceCard: true }), 1500);
  }

  get mileageCatoryOptions() {
    return VEHICLE_MILEAGE_CATEGORIES.map(c => ({ label: c, value: c }));
  }

  get tripleCheckProps() {
    let props = ['task_QC_Quality_Check'];

    return props;
  }

  setField = (name, value) => {
    this.setState(prevState => ({
      ...prevState,
      changed: { ...prevState.changed, [name]: value },
    }));
  };

  renderPlannable(name) {
    let TASK_REMARK_TYPE = '';
    env.clientId == AppClientId.INDEWAL ? (TASK_REMARK_TYPE = name.replace('task_', '')) : (TASK_REMARK_TYPE = name);

    //use the fetched vehicle in the modal
    return (
      <HBox key={name}>
        <HBox>
          <VehiclePropertyCheckbox
            vehicleId={this.vehicle.id}
            propertyName={name}
            changedValue={this.state.changed[name]}
            setField={this.setField.bind(this)}
          />
        </HBox>
        {this.props.workTaskRemarks ? (
          <Loader small />
        ) : (
          <KanbanVehicleRemarks
            readOnly
            noWrap
            taskName={TASK_REMARK_TYPE}
            kanbanBoardLabel={this.props.board?.label}
            vehicleId={this.vehicle?.id}
            loggedUserId={this.props.loggedInUserId}
          />
        )}
      </HBox>
    );
  }

  renderTripleCheck(name) {
    let val = this.propertyValue(name);
    let state = val == 1 ? 1 : val == 2 || val == 4 ? 4 : 0;

    return (
     
        <div className={`triple triple-${state} ${this.props.work ? 'disabled' : ''}`}>
          {/* <div className="label">{this.lbl(`vehicle.property.${name}`)}</div> */}
          <VehiclePropertyLoadable name={name}>
            <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
              <input
                type="radio"
                className="btn-check"
                name={`btnradio-${name}`} // uniek per veld
                id={`btnradio1-${name}`}
                autoComplete="off"
                checked={state == 0}
                onChange={() => this.props.setProperty(name, 0)}
              />
              <label className="btn btn-outline-primary" htmlFor={`btnradio1-${name}`}>
                {this.lbl('vehicle.details.task_card.task.name.task_qc_contacted')}
              </label>

              <input
                type="radio"
                className="btn-check"
                name={`btnradio-${name}`}
                id={`btnradio2-${name}`}
                autoComplete="off"
                checked={state == 1}
                onChange={() => this.props.setProperty(name, 1)}
              />
              <label className="btn btn-outline-primary" htmlFor={`btnradio2-${name}`}>
                {this.lbl('vehicle.details.task_card.task.name.task_qc_get_in_touch')}
              </label>

              <input
                type="radio"
                className="btn-check"
                name={`btnradio-${name}`}
                id={`btnradio3-${name}`}
                autoComplete="off"
                checked={state == 4}
                onChange={() => this.props.setProperty(name, 2)}
              />
              <label className="btn btn-outline-primary" htmlFor={`btnradio3-${name}`}>
                {this.lbl('vehicle.details.task_card.task.name.task_qc_no_action_needed')}
              </label>
            </div>
          </VehiclePropertyLoadable>
        </div>
     
    );
  }

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id, this.state.regplate_code);
  }

  propertyValue(name) {
    return this.vehicle[name];
  }

  get vehicle() {
    return this.props.vehicle || this.props.cell.vehicle;
  }

  renderPane(name, title, content) {
    return (
      <>
        <div className="d-flex w-100">
          <div className={cn(styles.accordionHeader)} onClick={this.setStateFn({ [name]: !this.state[name] })}>
            {title}
          </div>
          <div
            className={cn(styles.accordionIcon, { [styles.openAccordionIcon]: this.state[name] })}
            onClick={this.setStateFn({ [name]: !this.state[name] })}
          >
            {this.state[name] ? <IsClosed /> : <IsOpen />}{' '}
          </div>
        </div>
        {this.state[name] ? content : null}
      </>
    );
  }

  renderApprove() {
    if (!this.state.approve) return null;

    return (
      <ModalComponent
        size={'modal-lg'}
        onClose={this.reset.bind(this)}
        title={
          <>
            {this.props.fullFetch ? (
              <>
                <Loader small />
                &nbsp;
              </>
            ) : null}
            {this.props.action.label}
          </>
        }
      >
        <WithVehicle loader vehicle_id={this.vehicle.id}>
       
          <div className="mb-2">
            <VehicleHeader vehicle={this.vehicle} hooikammer brandTopPosition />
          </div>
          {this.state.showOutgoingInvoiceCard && this.vehicle.status == '3' ? <VehicleOutgoingInvoiceCard vehicle={this.vehicle} /> : null}

          <Container>{this.renderModalBody()}</Container>
        </WithVehicle>
      </ModalComponent>
    );
  }

  renderModalBody() {
    let shownFields = { ...VEHICLE_TASK_FIELDS };

    for (let name in shownFields) {
      if (!!this.vehicle[name]) {
        shownFields[name] = this.vehicle[name];
      }
    }

    this.setState({ ...shownFields });
    return (
      <>
        <div className={s.GridContainer}>
          <Card className={cn('vehicle-info-card info-card data wide', styles.card)}>
            <VBox>
              {this.renderPane(
                'Voertuiggegevens',
                this.lbl('interior.inspection.vehicledata'),
                <VBox className="manco-list" key="manco">
                  <Row>
                    <Cell>{this.lbl(`vehicle.property.brand_name`)}</Cell>
                    <Cell className={'cell-value'}>
                      <strong>
                        {this.vehicle.brand_name ?? ''}&nbsp;{this.vehicle.model_name ?? ''}
                      </strong>
                    </Cell>
                  </Row>
                  <Row>
                    <Cell>{this.lbl(`vehicle.property.model_info `)}</Cell>
                    <Cell className={'cell-value'}>{this.vehicle.model_info}</Cell>
                  </Row>
                  <Row>
                    <Cell>{this.lbl(`vehicle.property.date_first_allowance `)}</Cell>

                    <Cell className={'cell-value'}>{this.vehicle.date_first_allowance}</Cell>
                  </Row>
                  <Row>
                    <Cell>{this.lbl(`vehicle.property.mileage `)}</Cell>

                    <Cell className={'cell-value'}>{parseInt(this.vehicle?.mileage || '0').toLocaleString() + ' km'}</Cell>
                  </Row>
                  <Row>
                    <Cell>{this.lbl(`vehicle.property.vin `)}</Cell>

                    <Cell className={'cell-value'}>{this.vehicle.vin}</Cell>
                  </Row>
                </VBox>,
              )}

              {this.renderPane(
                'purchase_data',
                this.lbl('vehicle.info.finance.purchase.purchasing_data'),
                <>
                <HBox left>
                  <VehicleFinancePurchaseCard vehicle={this.vehicle} />
                  </HBox>
                 
                </>
              )}
            
                     
              
            </VBox>
          </Card>
          <Card className={cn('vehicle-info-card info-card data wide', styles.card)}>
            <VBox key="body">
              {this.renderPane(
                'Remarks',
                this.lbl('inspection.attention.incident.remarks'),
                <VBox className="manco-list" key="manco">
                  <KanbanVehicleRemarks
                    taskName={''}
                    kanbanBoardLabel={this.props.board?.label}
                    vehicleId={this.vehicle.id}
                    loggedUserId={this.props.me?.id}
                  />
                </VBox>,
              )}

     

              {this.renderPane(
                'Tasks',
                this.lbl('vehicle.details.tasks'),
                <VBox className="manco-list" key="manco">
                  <VBox>
                    <div>&nbsp;</div>
                    {_.map(shownFields, (value, name) => this.renderPlannable(name))}
                  </VBox>
                </VBox>,
              )}
              <VBox className="manco-list" key="manco">
                {/* <HBox left>
                  <VehiclePropertyLoadable name="mileage_category">
                    <VBox>
                      <div className="label mb-2">{this.lbl(`vehicle.property.mileage_category`)}</div>
                      <SearchSelect
                        options={this.mileageCatoryOptions}
                        value={{ label: this.vehicle.mileage_category }}
                        onChange={e => {
                          this.props.setProperty('mileage_category', e.value);
                        }}
                      />
                    </VBox>
                  </VehiclePropertyLoadable>
                </HBox> */}
              </VBox>
            </VBox>
          </Card>
        </div>
        <div className="d-flex justify-content-center gap-2 mt-3">
        
            {this.tripleCheckProps.map(name => this.renderTripleCheck(name))}
      
        </div>
        <div className="d-flex justify-content-center gap-2 mt-3">
          <PerformActionButton
            disabled={!this.vehicle.task_QC_Quality_Check}
            className={styles.confirmButton}
            action={this.props.action}
            target={this.vehicle}
            onChange={() => {
              this.reset();
            }}
            name={this.lbl('done')}
          />

<ButtonComponent
  style={'ButtonSoftDelete'}
  onClick={() => {
    const confirmed = window.confirm('Weet je zeker dat je de taak wilt overrulen?');
    if (confirmed) {
      this.props.setProperty('overrule_QC', '1');
      this.reset();
    }
  }}
>
  Overrule taak
</ButtonComponent>
           
          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </>
    );
  }

  render() {
    const vehicle = this.vehicle;

    if (!vehicle || !this.props.allOptions) return <Loader small />;

    if (this.props.vehicleDetails)
      return (
        <Container>
          <HBox right>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                <Button
                  style={'ButtonSoftEditFullWidth'}
                  onClick={this.setStateFn({
                    approve: !this.state.approve,
                  })}
                >
                  <b> {this.props.column.label}</b>
                </Button>
              </>
            )}
          </HBox>
          {this.renderApprove()}
        </Container>
      );

    return (
      <ActionCell className={styles.cell}>
        <Container>
          <VehicleHeader vehicle={vehicle} hooikammer />

          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <div className={styles.cellButtonContainer}>
                <CellButton
                  onClick={this.setStateFn({ approve: !this.state.approve, regplate_code: vehicle.regplate_code || '' })}
                >
                  <View />
                </CellButton>
              </div>
            )}
          </CellButtons>
          {this.renderApprove()}
        </Container>
      </ActionCell>
    );
  }

  onCommentChange = e => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };
}

IDWE_quality_check_commerceComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    me: selectMe(),
    allOptions: selectAllOptions(),
    vehicle: selectVehicle(ownProps.cell.vehicle.id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    confirm(vehicle_id, regplate_code) {
      dispatch(performAction(ownProps.action.id, vehicle_id, { regplate_code }));
    },

    setProperty(name, value) {
      dispatch(setVehicleProperty(ownProps.cell.vehicle.id, name, value));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const IDWE_quality_check_commerce = compose(withConnect, withRouter)(IDWE_quality_check_commerceComp);
